var Y = (e, r, t) => new Promise((n, a) => {
  var o = (y) => {
    try {
      l(t.next(y));
    } catch (i) {
      a(i);
    }
  }, v = (y) => {
    try {
      l(t.throw(y));
    } catch (i) {
      a(i);
    }
  }, l = (y) => y.done ? n(y.value) : Promise.resolve(y.value).then(o, v);
  l((t = t.apply(e, r)).next());
});
const $ = {
  logError(...e) {
    console && console.error && console.error(...e);
  },
  logWarn(...e) {
    console && console.warn && console.warn(...e);
  },
  logInfo(...e) {
    console && console.info && console.info(...e);
  }
};
function qr(e) {
  Object.assign($, e);
}
let ne = {}, H, ke = setTimeout(() => {
});
function Ue(e, r = () => {
}) {
  const t = typeof e == "string" ? JSON.parse(e) : e;
  return H && H >= t.createdAt ? {} : (H = t.createdAt, H ? ($.logInfo(`Loading new feature config - created at: ${H}`), ne = {}, t.features.forEach((n) => {
    ne[n.key] = n;
  }), r(), t) : {});
}
function Tr(e, r, t) {
  return Y(this, null, function* () {
    const n = e.key ? `-${e.key}` : "", o = `${e.host || "https://features.api.justeattakeaway.com"}/config/v1/${e.scope}/${e.environment}${n}`;
    function v() {
      return Y(this, null, function* () {
        const y = yield r.get(o);
        return Ue(y.data, t), y.data;
      });
    }
    const l = yield v();
    return clearInterval(ke), e.poll && (ke = setInterval(() => Y(this, null, function* () {
      yield v();
    }), e.pollInterval || 3e4)), l;
  });
}
function Ur(e) {
  return ne[e];
}
function Pr() {
  return ne;
}
function Nr() {
  return null;
}
var cr = /* @__PURE__ */ ((e) => (e.And = "and", e.Or = "or", e.Eq = "eq", e.Neq = "neq", e.In = "in", e.Nin = "nin", e.Gt = "gt", e.Gte = "gte", e.Lt = "lt", e.Lte = "lte", e))(cr || {});
function $r(e) {
  const r = Object.values(cr).filter((t) => typeof e[t] != "undefined");
  if (r.length > 1)
    throw new Error(`Multiple operators specified (${r.join(", ")})`);
}
function dr(e, r) {
  const { property: t } = e;
  if (!r.size)
    throw new Error("No restriction properties found");
  if (!r.has(t))
    throw new Error(`Unexpected restriction property: ${t}`);
  const n = r.get(t);
  if (typeof n == "function")
    return n();
  throw new Error("No restriction properties found");
}
function V(e, r, t) {
  const n = dr(r, t.restrictionsProviders);
  return e.toLowerCase() === (n == null ? void 0 : n.toLowerCase());
}
const Lr = (e, r) => e.localeCompare(r, void 0, {
  ignorePunctuation: !0,
  numeric: !0,
  sensitivity: "base"
});
function Ie(e, r, { property: t }) {
  if (t === "AppVersion")
    return Lr(e, r) === 1;
  throw new Error(`Property is not comparable: ${t}`);
}
function Z(e, r, t) {
  const n = dr(r, t.restrictionsProviders), a = r[e], o = V(a, r, t);
  return [
    "eq",
    "gte",
    "lte"
    /* Lte */
  ].includes(e) && o ? !0 : [
    "gt",
    "gte"
    /* Gte */
  ].includes(e) ? Ie(n, a, r) : [
    "lt",
    "lte"
    /* Lte */
  ].includes(e) ? Ie(a, n, r) : !1;
}
function ae(e, r) {
  try {
    return $r(e), e.and ? e.and.every((t) => ae(t, r)) : e.or ? e.or.some((t) => ae(t, r)) : e.eq ? V(e.eq, e, r) : e.neq ? !V(e.neq, e, r) : e.in ? e.in.some((t) => V(t, e, r)) : e.nin ? e.nin.every((t) => !V(t, e, r)) : e.gt ? Z("gt", e, r) : e.gte ? Z("gte", e, r) : e.lt ? Z("lt", e, r) : e.lte ? Z("lte", e, r) : !0;
  } catch (t) {
    const n = t instanceof Error ? t.message : "Unknown error";
    return $.logWarn(n, null, { error: t }), !1;
  }
}
var M = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function Pe(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Fr(e) {
  if (e.__esModule)
    return e;
  var r = e.default;
  if (typeof r == "function") {
    var t = function n() {
      if (this instanceof n) {
        var a = [null];
        a.push.apply(a, arguments);
        var o = Function.bind.apply(r, a);
        return new o();
      }
      return r.apply(this, arguments);
    };
    t.prototype = r.prototype;
  } else
    t = {};
  return Object.defineProperty(t, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var a = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(t, n, a.get ? a : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), t;
}
var hr = { exports: {} };
function kr(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var fe = { exports: {} };
const Ir = {}, jr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ir
}, Symbol.toStringTag, { value: "Module" })), Dr = /* @__PURE__ */ Fr(jr);
var je;
function pr() {
  return je || (je = 1, function(e, r) {
    (function(t, n) {
      e.exports = n();
    })(M, function() {
      var t = t || function(n, a) {
        var o;
        if (typeof window != "undefined" && window.crypto && (o = window.crypto), typeof self != "undefined" && self.crypto && (o = self.crypto), typeof globalThis != "undefined" && globalThis.crypto && (o = globalThis.crypto), !o && typeof window != "undefined" && window.msCrypto && (o = window.msCrypto), !o && typeof M != "undefined" && M.crypto && (o = M.crypto), !o && typeof kr == "function")
          try {
            o = Dr;
          } catch (s) {
          }
        var v = function() {
          if (o) {
            if (typeof o.getRandomValues == "function")
              try {
                return o.getRandomValues(new Uint32Array(1))[0];
              } catch (s) {
              }
            if (typeof o.randomBytes == "function")
              try {
                return o.randomBytes(4).readInt32LE();
              } catch (s) {
              }
          }
          throw new Error("Native crypto module could not be used to get secure random number.");
        }, l = Object.create || function() {
          function s() {
          }
          return function(m) {
            var u;
            return s.prototype = m, u = new s(), s.prototype = null, u;
          };
        }(), y = {}, i = y.lib = {}, g = i.Base = function() {
          return {
            /**
             * Creates a new object that inherits from this object.
             *
             * @param {Object} overrides Properties to copy into the new object.
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         field: 'value',
             *
             *         method: function () {
             *         }
             *     });
             */
            extend: function(s) {
              var m = l(this);
              return s && m.mixIn(s), (!m.hasOwnProperty("init") || this.init === m.init) && (m.init = function() {
                m.$super.init.apply(this, arguments);
              }), m.init.prototype = m, m.$super = this, m;
            },
            /**
             * Extends this object and runs the init method.
             * Arguments to create() will be passed to init().
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var instance = MyType.create();
             */
            create: function() {
              var s = this.extend();
              return s.init.apply(s, arguments), s;
            },
            /**
             * Initializes a newly created object.
             * Override this method to add some logic when your objects are created.
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         init: function () {
             *             // ...
             *         }
             *     });
             */
            init: function() {
            },
            /**
             * Copies properties into this object.
             *
             * @param {Object} properties The properties to mix in.
             *
             * @example
             *
             *     MyType.mixIn({
             *         field: 'value'
             *     });
             */
            mixIn: function(s) {
              for (var m in s)
                s.hasOwnProperty(m) && (this[m] = s[m]);
              s.hasOwnProperty("toString") && (this.toString = s.toString);
            },
            /**
             * Creates a copy of this object.
             *
             * @return {Object} The clone.
             *
             * @example
             *
             *     var clone = instance.clone();
             */
            clone: function() {
              return this.init.prototype.extend(this);
            }
          };
        }(), f = i.WordArray = g.extend({
          /**
           * Initializes a newly created word array.
           *
           * @param {Array} words (Optional) An array of 32-bit words.
           * @param {number} sigBytes (Optional) The number of significant bytes in the words.
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.create();
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
           */
          init: function(s, m) {
            s = this.words = s || [], m != a ? this.sigBytes = m : this.sigBytes = s.length * 4;
          },
          /**
           * Converts this word array to a string.
           *
           * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
           *
           * @return {string} The stringified word array.
           *
           * @example
           *
           *     var string = wordArray + '';
           *     var string = wordArray.toString();
           *     var string = wordArray.toString(CryptoJS.enc.Utf8);
           */
          toString: function(s) {
            return (s || C).stringify(this);
          },
          /**
           * Concatenates a word array to this word array.
           *
           * @param {WordArray} wordArray The word array to append.
           *
           * @return {WordArray} This word array.
           *
           * @example
           *
           *     wordArray1.concat(wordArray2);
           */
          concat: function(s) {
            var m = this.words, u = s.words, E = this.sigBytes, x = s.sigBytes;
            if (this.clamp(), E % 4)
              for (var S = 0; S < x; S++) {
                var q = u[S >>> 2] >>> 24 - S % 4 * 8 & 255;
                m[E + S >>> 2] |= q << 24 - (E + S) % 4 * 8;
              }
            else
              for (var O = 0; O < x; O += 4)
                m[E + O >>> 2] = u[O >>> 2];
            return this.sigBytes += x, this;
          },
          /**
           * Removes insignificant bits.
           *
           * @example
           *
           *     wordArray.clamp();
           */
          clamp: function() {
            var s = this.words, m = this.sigBytes;
            s[m >>> 2] &= 4294967295 << 32 - m % 4 * 8, s.length = n.ceil(m / 4);
          },
          /**
           * Creates a copy of this word array.
           *
           * @return {WordArray} The clone.
           *
           * @example
           *
           *     var clone = wordArray.clone();
           */
          clone: function() {
            var s = g.clone.call(this);
            return s.words = this.words.slice(0), s;
          },
          /**
           * Creates a word array filled with random bytes.
           *
           * @param {number} nBytes The number of random bytes to generate.
           *
           * @return {WordArray} The random word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.random(16);
           */
          random: function(s) {
            for (var m = [], u = 0; u < s; u += 4)
              m.push(v());
            return new f.init(m, s);
          }
        }), R = y.enc = {}, C = R.Hex = {
          /**
           * Converts a word array to a hex string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The hex string.
           *
           * @static
           *
           * @example
           *
           *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
           */
          stringify: function(s) {
            for (var m = s.words, u = s.sigBytes, E = [], x = 0; x < u; x++) {
              var S = m[x >>> 2] >>> 24 - x % 4 * 8 & 255;
              E.push((S >>> 4).toString(16)), E.push((S & 15).toString(16));
            }
            return E.join("");
          },
          /**
           * Converts a hex string to a word array.
           *
           * @param {string} hexStr The hex string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
           */
          parse: function(s) {
            for (var m = s.length, u = [], E = 0; E < m; E += 2)
              u[E >>> 3] |= parseInt(s.substr(E, 2), 16) << 24 - E % 8 * 4;
            return new f.init(u, m / 2);
          }
        }, _ = R.Latin1 = {
          /**
           * Converts a word array to a Latin1 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The Latin1 string.
           *
           * @static
           *
           * @example
           *
           *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
           */
          stringify: function(s) {
            for (var m = s.words, u = s.sigBytes, E = [], x = 0; x < u; x++) {
              var S = m[x >>> 2] >>> 24 - x % 4 * 8 & 255;
              E.push(String.fromCharCode(S));
            }
            return E.join("");
          },
          /**
           * Converts a Latin1 string to a word array.
           *
           * @param {string} latin1Str The Latin1 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
           */
          parse: function(s) {
            for (var m = s.length, u = [], E = 0; E < m; E++)
              u[E >>> 2] |= (s.charCodeAt(E) & 255) << 24 - E % 4 * 8;
            return new f.init(u, m);
          }
        }, w = R.Utf8 = {
          /**
           * Converts a word array to a UTF-8 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-8 string.
           *
           * @static
           *
           * @example
           *
           *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
           */
          stringify: function(s) {
            try {
              return decodeURIComponent(escape(_.stringify(s)));
            } catch (m) {
              throw new Error("Malformed UTF-8 data");
            }
          },
          /**
           * Converts a UTF-8 string to a word array.
           *
           * @param {string} utf8Str The UTF-8 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
           */
          parse: function(s) {
            return _.parse(unescape(encodeURIComponent(s)));
          }
        }, b = i.BufferedBlockAlgorithm = g.extend({
          /**
           * Resets this block algorithm's data buffer to its initial state.
           *
           * @example
           *
           *     bufferedBlockAlgorithm.reset();
           */
          reset: function() {
            this._data = new f.init(), this._nDataBytes = 0;
          },
          /**
           * Adds new data to this block algorithm's buffer.
           *
           * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
           *
           * @example
           *
           *     bufferedBlockAlgorithm._append('data');
           *     bufferedBlockAlgorithm._append(wordArray);
           */
          _append: function(s) {
            typeof s == "string" && (s = w.parse(s)), this._data.concat(s), this._nDataBytes += s.sigBytes;
          },
          /**
           * Processes available data blocks.
           *
           * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
           *
           * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
           *
           * @return {WordArray} The processed data.
           *
           * @example
           *
           *     var processedData = bufferedBlockAlgorithm._process();
           *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
           */
          _process: function(s) {
            var m, u = this._data, E = u.words, x = u.sigBytes, S = this.blockSize, q = S * 4, O = x / q;
            s ? O = n.ceil(O) : O = n.max((O | 0) - this._minBufferSize, 0);
            var A = O * S, U = n.min(A * 4, x);
            if (A) {
              for (var T = 0; T < A; T += S)
                this._doProcessBlock(E, T);
              m = E.splice(0, A), u.sigBytes -= U;
            }
            return new f.init(m, U);
          },
          /**
           * Creates a copy of this object.
           *
           * @return {Object} The clone.
           *
           * @example
           *
           *     var clone = bufferedBlockAlgorithm.clone();
           */
          clone: function() {
            var s = g.clone.call(this);
            return s._data = this._data.clone(), s;
          },
          _minBufferSize: 0
        });
        i.Hasher = b.extend({
          /**
           * Configuration options.
           */
          cfg: g.extend(),
          /**
           * Initializes a newly created hasher.
           *
           * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
           *
           * @example
           *
           *     var hasher = CryptoJS.algo.SHA256.create();
           */
          init: function(s) {
            this.cfg = this.cfg.extend(s), this.reset();
          },
          /**
           * Resets this hasher to its initial state.
           *
           * @example
           *
           *     hasher.reset();
           */
          reset: function() {
            b.reset.call(this), this._doReset();
          },
          /**
           * Updates this hasher with a message.
           *
           * @param {WordArray|string} messageUpdate The message to append.
           *
           * @return {Hasher} This hasher.
           *
           * @example
           *
           *     hasher.update('message');
           *     hasher.update(wordArray);
           */
          update: function(s) {
            return this._append(s), this._process(), this;
          },
          /**
           * Finalizes the hash computation.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} messageUpdate (Optional) A final message update.
           *
           * @return {WordArray} The hash.
           *
           * @example
           *
           *     var hash = hasher.finalize();
           *     var hash = hasher.finalize('message');
           *     var hash = hasher.finalize(wordArray);
           */
          finalize: function(s) {
            s && this._append(s);
            var m = this._doFinalize();
            return m;
          },
          blockSize: 16,
          /**
           * Creates a shortcut function to a hasher's object interface.
           *
           * @param {Hasher} hasher The hasher to create a helper for.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
           */
          _createHelper: function(s) {
            return function(m, u) {
              return new s.init(u).finalize(m);
            };
          },
          /**
           * Creates a shortcut function to the HMAC's object interface.
           *
           * @param {Hasher} hasher The hasher to use in this HMAC helper.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
           */
          _createHmacHelper: function(s) {
            return function(m, u) {
              return new B.HMAC.init(s, u).finalize(m);
            };
          }
        });
        var B = y.algo = {};
        return y;
      }(Math);
      return t;
    });
  }(fe)), fe.exports;
}
(function(e, r) {
  (function(t, n) {
    e.exports = n(pr());
  })(M, function(t) {
    return function(n) {
      var a = t, o = a.lib, v = o.WordArray, l = o.Hasher, y = a.algo, i = [];
      (function() {
        for (var w = 0; w < 64; w++)
          i[w] = n.abs(n.sin(w + 1)) * 4294967296 | 0;
      })();
      var g = y.MD5 = l.extend({
        _doReset: function() {
          this._hash = new v.init([
            1732584193,
            4023233417,
            2562383102,
            271733878
          ]);
        },
        _doProcessBlock: function(w, b) {
          for (var B = 0; B < 16; B++) {
            var s = b + B, m = w[s];
            w[s] = (m << 8 | m >>> 24) & 16711935 | (m << 24 | m >>> 8) & 4278255360;
          }
          var u = this._hash.words, E = w[b + 0], x = w[b + 1], S = w[b + 2], q = w[b + 3], O = w[b + 4], A = w[b + 5], U = w[b + 6], T = w[b + 7], I = w[b + 8], F = w[b + 9], z = w[b + 10], J = w[b + 11], X = w[b + 12], G = w[b + 13], K = w[b + 14], Q = w[b + 15], c = u[0], d = u[1], h = u[2], p = u[3];
          c = f(c, d, h, p, E, 7, i[0]), p = f(p, c, d, h, x, 12, i[1]), h = f(h, p, c, d, S, 17, i[2]), d = f(d, h, p, c, q, 22, i[3]), c = f(c, d, h, p, O, 7, i[4]), p = f(p, c, d, h, A, 12, i[5]), h = f(h, p, c, d, U, 17, i[6]), d = f(d, h, p, c, T, 22, i[7]), c = f(c, d, h, p, I, 7, i[8]), p = f(p, c, d, h, F, 12, i[9]), h = f(h, p, c, d, z, 17, i[10]), d = f(d, h, p, c, J, 22, i[11]), c = f(c, d, h, p, X, 7, i[12]), p = f(p, c, d, h, G, 12, i[13]), h = f(h, p, c, d, K, 17, i[14]), d = f(d, h, p, c, Q, 22, i[15]), c = R(c, d, h, p, x, 5, i[16]), p = R(p, c, d, h, U, 9, i[17]), h = R(h, p, c, d, J, 14, i[18]), d = R(d, h, p, c, E, 20, i[19]), c = R(c, d, h, p, A, 5, i[20]), p = R(p, c, d, h, z, 9, i[21]), h = R(h, p, c, d, Q, 14, i[22]), d = R(d, h, p, c, O, 20, i[23]), c = R(c, d, h, p, F, 5, i[24]), p = R(p, c, d, h, K, 9, i[25]), h = R(h, p, c, d, q, 14, i[26]), d = R(d, h, p, c, I, 20, i[27]), c = R(c, d, h, p, G, 5, i[28]), p = R(p, c, d, h, S, 9, i[29]), h = R(h, p, c, d, T, 14, i[30]), d = R(d, h, p, c, X, 20, i[31]), c = C(c, d, h, p, A, 4, i[32]), p = C(p, c, d, h, I, 11, i[33]), h = C(h, p, c, d, J, 16, i[34]), d = C(d, h, p, c, K, 23, i[35]), c = C(c, d, h, p, x, 4, i[36]), p = C(p, c, d, h, O, 11, i[37]), h = C(h, p, c, d, T, 16, i[38]), d = C(d, h, p, c, z, 23, i[39]), c = C(c, d, h, p, G, 4, i[40]), p = C(p, c, d, h, E, 11, i[41]), h = C(h, p, c, d, q, 16, i[42]), d = C(d, h, p, c, U, 23, i[43]), c = C(c, d, h, p, F, 4, i[44]), p = C(p, c, d, h, X, 11, i[45]), h = C(h, p, c, d, Q, 16, i[46]), d = C(d, h, p, c, S, 23, i[47]), c = _(c, d, h, p, E, 6, i[48]), p = _(p, c, d, h, T, 10, i[49]), h = _(h, p, c, d, K, 15, i[50]), d = _(d, h, p, c, A, 21, i[51]), c = _(c, d, h, p, X, 6, i[52]), p = _(p, c, d, h, q, 10, i[53]), h = _(h, p, c, d, z, 15, i[54]), d = _(d, h, p, c, x, 21, i[55]), c = _(c, d, h, p, I, 6, i[56]), p = _(p, c, d, h, Q, 10, i[57]), h = _(h, p, c, d, U, 15, i[58]), d = _(d, h, p, c, G, 21, i[59]), c = _(c, d, h, p, O, 6, i[60]), p = _(p, c, d, h, J, 10, i[61]), h = _(h, p, c, d, S, 15, i[62]), d = _(d, h, p, c, F, 21, i[63]), u[0] = u[0] + c | 0, u[1] = u[1] + d | 0, u[2] = u[2] + h | 0, u[3] = u[3] + p | 0;
        },
        _doFinalize: function() {
          var w = this._data, b = w.words, B = this._nDataBytes * 8, s = w.sigBytes * 8;
          b[s >>> 5] |= 128 << 24 - s % 32;
          var m = n.floor(B / 4294967296), u = B;
          b[(s + 64 >>> 9 << 4) + 15] = (m << 8 | m >>> 24) & 16711935 | (m << 24 | m >>> 8) & 4278255360, b[(s + 64 >>> 9 << 4) + 14] = (u << 8 | u >>> 24) & 16711935 | (u << 24 | u >>> 8) & 4278255360, w.sigBytes = (b.length + 1) * 4, this._process();
          for (var E = this._hash, x = E.words, S = 0; S < 4; S++) {
            var q = x[S];
            x[S] = (q << 8 | q >>> 24) & 16711935 | (q << 24 | q >>> 8) & 4278255360;
          }
          return E;
        },
        clone: function() {
          var w = l.clone.call(this);
          return w._hash = this._hash.clone(), w;
        }
      });
      function f(w, b, B, s, m, u, E) {
        var x = w + (b & B | ~b & s) + m + E;
        return (x << u | x >>> 32 - u) + b;
      }
      function R(w, b, B, s, m, u, E) {
        var x = w + (b & s | B & ~s) + m + E;
        return (x << u | x >>> 32 - u) + b;
      }
      function C(w, b, B, s, m, u, E) {
        var x = w + (b ^ B ^ s) + m + E;
        return (x << u | x >>> 32 - u) + b;
      }
      function _(w, b, B, s, m, u, E) {
        var x = w + (B ^ (b | ~s)) + m + E;
        return (x << u | x >>> 32 - u) + b;
      }
      a.MD5 = l._createHelper(g), a.HmacMD5 = l._createHmacHelper(g);
    }(Math), t.MD5;
  });
})(hr);
var Hr = hr.exports;
const Vr = /* @__PURE__ */ Pe(Hr);
var Mr = pr();
const vr = /* @__PURE__ */ Pe(Mr);
function Wr(e) {
  const r = [];
  for (let t = 0; t < e.length; t++)
    r[t / 4 | 0] |= e[t] << 24 - 8 * t;
  return vr.lib.WordArray.create(r, e.length);
}
function zr(e, r) {
  const t = [];
  return r > 0 && t.push(e >>> 24), r > 1 && t.push(e >>> 16 & 255), r > 2 && t.push(e >>> 8 & 255), r > 3 && t.push(e & 255), t;
}
function mr(e, r) {
  let t = e, n = r;
  Object.prototype.hasOwnProperty.call(t, "sigBytes") && Object.prototype.hasOwnProperty.call(t, "words") && (n = t.sigBytes, t = t.words);
  const a = [];
  let o, v = 0;
  for (; n > 0; )
    o = zr(t[v], Math.min(4, n)), n -= o.length, a.push(o), v++;
  return [].concat.apply([], a);
}
function De(e) {
  const r = Vr(e), t = mr(r);
  return ((t[1] << 8) + t[0]) / 65535;
}
function Jr(e) {
  const r = vr.enc.Utf8.parse(e), t = De(r), n = mr(r);
  n[0] ^= 1;
  const a = Wr(n), o = De(a);
  return { audienceFraction: t, variantFraction: o };
}
function Xr(e, r) {
  return e.rules.find((t) => ae(t.restrictions, r)) || null;
}
function Gr(e, r) {
  if (e.bucketBy === "AnonUserId")
    return r.anonUserId;
  throw new Error("Unexpected bucketBy ", e.bucketBy);
}
function Kr(e, r) {
  if (r > 1)
    throw new Error(`Variant fraction must not be > 1, was ${r}.`);
  const t = e.variants.reduce((o, v) => o + v.weight, 0);
  let n = 0;
  const a = e.variants.find((o) => (n += o.weight / t, n >= r));
  if (!a)
    throw new Error("No matching variant found.");
  return a;
}
function Qr(e, r) {
  const t = Xr(e, r);
  if (!t)
    return null;
  const n = e.prefix + Gr(e, r), { audienceFraction: a, variantFraction: o } = Jr(n);
  return t.audienceFraction < a ? null : Kr(t, o);
}
const Yr = (e, r) => {
  if (!e.evaluationLogic)
    return null;
  try {
    const { type: t } = e.evaluationLogic;
    if (t === "IdHash")
      return Qr(e.evaluationLogic.detail, r);
  } catch (t) {
    const n = t instanceof Error ? t.message : "Unknown error";
    $.logError(n, { error: t });
  }
  return null;
}, Zr = (e, r) => {
  const t = e.defaultValueRules.find(
    (n) => ae(n.restrictions, r)
  );
  return t ? t.value : null;
}, et = (e, r) => {
  try {
    const { experimentKey: t, experimentVariant: n } = e;
    if (!t || !n)
      return;
    if (!r) {
      $.logWarn(
        `Experiment will not be tracked as no \`onTrack\` callback was provided (key: ${t}, variant: ${n})`
      );
      return;
    }
    $.logInfo(`Tracking experiment - key: ${t}, variant: ${n}`), r(t, n);
  } catch (t) {
    $.logError("An exception occurred while trying to send an experiment event", { error: t });
  }
};
class rt {
  constructor(r) {
    this.fm = r;
  }
  peekExperiments() {
    const r = [];
    return Object.keys(Pr()).sort().forEach((t) => {
      const n = t.replace(`${this.fm.settings.keyPrefix}::`, "");
      r.push({ key: t, value: this.fm.getValue(n, !1) });
    }), r;
  }
}
var Oe = /* @__PURE__ */ ((e) => (e.Bool = "bool", e.Int = "int", e.String = "string", e))(Oe || {});
class tt {
  constructor(r) {
    try {
      this.url = new URL(r);
    } catch (t) {
      $.logWarn(
        `[FeatureOverride] Invalid URL string '${r}'. Check your settings for the plugin`,
        { error: t }
      );
    }
  }
  getOverride(r, t) {
    if (!this.url)
      return null;
    const a = this.url.searchParams.get(`jet-fm-${r}`);
    if (!a)
      return null;
    try {
      let o = a;
      return t === Oe.Bool && (o = this.stringToBoolean(a)), t === Oe.Int && (o = this.stringToNumber(a)), console.log(`[FeatureOverride] The Feature '${r}' has been overridden with '${o}'.`), o;
    } catch (o) {
      const v = o instanceof Error ? o.message : "Unknown error";
      return console.log(
        `[FeatureOverride] The Feature '${r}' has an override value '${a}' but cannot be casted to '${t}'. [${v}]`
      ), null;
    }
  }
  stringToBoolean(r) {
    if (r.toLowerCase() === "true")
      return !0;
    if (r.toLowerCase() === "false")
      return !1;
    throw new Error("Cast error: Not a boolean");
  }
  stringToNumber(r) {
    const t = Number(r);
    if (isNaN(t))
      throw new Error("Cast error: Not a number");
    return t;
  }
}
var Ne = { exports: {} }, yr = function(r, t) {
  return function() {
    for (var a = new Array(arguments.length), o = 0; o < a.length; o++)
      a[o] = arguments[o];
    return r.apply(t, a);
  };
}, nt = yr, k = Object.prototype.toString;
function $e(e) {
  return Array.isArray(e);
}
function qe(e) {
  return typeof e == "undefined";
}
function at(e) {
  return e !== null && !qe(e) && e.constructor !== null && !qe(e.constructor) && typeof e.constructor.isBuffer == "function" && e.constructor.isBuffer(e);
}
function gr(e) {
  return k.call(e) === "[object ArrayBuffer]";
}
function it(e) {
  return k.call(e) === "[object FormData]";
}
function ot(e) {
  var r;
  return typeof ArrayBuffer != "undefined" && ArrayBuffer.isView ? r = ArrayBuffer.isView(e) : r = e && e.buffer && gr(e.buffer), r;
}
function st(e) {
  return typeof e == "string";
}
function ut(e) {
  return typeof e == "number";
}
function wr(e) {
  return e !== null && typeof e == "object";
}
function re(e) {
  if (k.call(e) !== "[object Object]")
    return !1;
  var r = Object.getPrototypeOf(e);
  return r === null || r === Object.prototype;
}
function ft(e) {
  return k.call(e) === "[object Date]";
}
function lt(e) {
  return k.call(e) === "[object File]";
}
function ct(e) {
  return k.call(e) === "[object Blob]";
}
function br(e) {
  return k.call(e) === "[object Function]";
}
function dt(e) {
  return wr(e) && br(e.pipe);
}
function ht(e) {
  return k.call(e) === "[object URLSearchParams]";
}
function pt(e) {
  return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
}
function vt() {
  return typeof navigator != "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS") ? !1 : typeof window != "undefined" && typeof document != "undefined";
}
function Le(e, r) {
  if (!(e === null || typeof e == "undefined"))
    if (typeof e != "object" && (e = [e]), $e(e))
      for (var t = 0, n = e.length; t < n; t++)
        r.call(null, e[t], t, e);
    else
      for (var a in e)
        Object.prototype.hasOwnProperty.call(e, a) && r.call(null, e[a], a, e);
}
function Te() {
  var e = {};
  function r(a, o) {
    re(e[o]) && re(a) ? e[o] = Te(e[o], a) : re(a) ? e[o] = Te({}, a) : $e(a) ? e[o] = a.slice() : e[o] = a;
  }
  for (var t = 0, n = arguments.length; t < n; t++)
    Le(arguments[t], r);
  return e;
}
function mt(e, r, t) {
  return Le(r, function(a, o) {
    t && typeof a == "function" ? e[o] = nt(a, t) : e[o] = a;
  }), e;
}
function yt(e) {
  return e.charCodeAt(0) === 65279 && (e = e.slice(1)), e;
}
var P = {
  isArray: $e,
  isArrayBuffer: gr,
  isBuffer: at,
  isFormData: it,
  isArrayBufferView: ot,
  isString: st,
  isNumber: ut,
  isObject: wr,
  isPlainObject: re,
  isUndefined: qe,
  isDate: ft,
  isFile: lt,
  isBlob: ct,
  isFunction: br,
  isStream: dt,
  isURLSearchParams: ht,
  isStandardBrowserEnv: vt,
  forEach: Le,
  merge: Te,
  extend: mt,
  trim: pt,
  stripBOM: yt
}, j = P;
function He(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var Er = function(r, t, n) {
  if (!t)
    return r;
  var a;
  if (n)
    a = n(t);
  else if (j.isURLSearchParams(t))
    a = t.toString();
  else {
    var o = [];
    j.forEach(t, function(y, i) {
      y === null || typeof y == "undefined" || (j.isArray(y) ? i = i + "[]" : y = [y], j.forEach(y, function(f) {
        j.isDate(f) ? f = f.toISOString() : j.isObject(f) && (f = JSON.stringify(f)), o.push(He(i) + "=" + He(f));
      }));
    }), a = o.join("&");
  }
  if (a) {
    var v = r.indexOf("#");
    v !== -1 && (r = r.slice(0, v)), r += (r.indexOf("?") === -1 ? "?" : "&") + a;
  }
  return r;
}, gt = P;
function ie() {
  this.handlers = [];
}
ie.prototype.use = function(r, t, n) {
  return this.handlers.push({
    fulfilled: r,
    rejected: t,
    synchronous: n ? n.synchronous : !1,
    runWhen: n ? n.runWhen : null
  }), this.handlers.length - 1;
};
ie.prototype.eject = function(r) {
  this.handlers[r] && (this.handlers[r] = null);
};
ie.prototype.forEach = function(r) {
  gt.forEach(this.handlers, function(n) {
    n !== null && r(n);
  });
};
var wt = ie, bt = P, Et = function(r, t) {
  bt.forEach(r, function(a, o) {
    o !== t && o.toUpperCase() === t.toUpperCase() && (r[t] = a, delete r[o]);
  });
}, xr = function(r, t, n, a, o) {
  return r.config = t, n && (r.code = n), r.request = a, r.response = o, r.isAxiosError = !0, r.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }, r;
}, le, Ve;
function Cr() {
  if (Ve)
    return le;
  Ve = 1;
  var e = xr;
  return le = function(t, n, a, o, v) {
    var l = new Error(t);
    return e(l, n, a, o, v);
  }, le;
}
var ce, Me;
function xt() {
  if (Me)
    return ce;
  Me = 1;
  var e = Cr();
  return ce = function(t, n, a) {
    var o = a.config.validateStatus;
    !a.status || !o || o(a.status) ? t(a) : n(e(
      "Request failed with status code " + a.status,
      a.config,
      null,
      a.request,
      a
    ));
  }, ce;
}
var de, We;
function Ct() {
  if (We)
    return de;
  We = 1;
  var e = P;
  return de = e.isStandardBrowserEnv() ? (
    // Standard browser envs support document.cookie
    function() {
      return {
        write: function(n, a, o, v, l, y) {
          var i = [];
          i.push(n + "=" + encodeURIComponent(a)), e.isNumber(o) && i.push("expires=" + new Date(o).toGMTString()), e.isString(v) && i.push("path=" + v), e.isString(l) && i.push("domain=" + l), y === !0 && i.push("secure"), document.cookie = i.join("; ");
        },
        read: function(n) {
          var a = document.cookie.match(new RegExp("(^|;\\s*)(" + n + ")=([^;]*)"));
          return a ? decodeURIComponent(a[3]) : null;
        },
        remove: function(n) {
          this.write(n, "", Date.now() - 864e5);
        }
      };
    }()
  ) : (
    // Non standard browser env (web workers, react-native) lack needed support.
    function() {
      return {
        write: function() {
        },
        read: function() {
          return null;
        },
        remove: function() {
        }
      };
    }()
  ), de;
}
var he, ze;
function Rt() {
  return ze || (ze = 1, he = function(r) {
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(r);
  }), he;
}
var pe, Je;
function _t() {
  return Je || (Je = 1, pe = function(r, t) {
    return t ? r.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "") : r;
  }), pe;
}
var ve, Xe;
function St() {
  if (Xe)
    return ve;
  Xe = 1;
  var e = Rt(), r = _t();
  return ve = function(n, a) {
    return n && !e(a) ? r(n, a) : a;
  }, ve;
}
var me, Ge;
function Bt() {
  if (Ge)
    return me;
  Ge = 1;
  var e = P, r = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
  ];
  return me = function(n) {
    var a = {}, o, v, l;
    return n && e.forEach(n.split(`
`), function(i) {
      if (l = i.indexOf(":"), o = e.trim(i.substr(0, l)).toLowerCase(), v = e.trim(i.substr(l + 1)), o) {
        if (a[o] && r.indexOf(o) >= 0)
          return;
        o === "set-cookie" ? a[o] = (a[o] ? a[o] : []).concat([v]) : a[o] = a[o] ? a[o] + ", " + v : v;
      }
    }), a;
  }, me;
}
var ye, Ke;
function At() {
  if (Ke)
    return ye;
  Ke = 1;
  var e = P;
  return ye = e.isStandardBrowserEnv() ? (
    // Standard browser envs have full support of the APIs needed to test
    // whether the request URL is of the same origin as current location.
    function() {
      var t = /(msie|trident)/i.test(navigator.userAgent), n = document.createElement("a"), a;
      function o(v) {
        var l = v;
        return t && (n.setAttribute("href", l), l = n.href), n.setAttribute("href", l), {
          href: n.href,
          protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
          host: n.host,
          search: n.search ? n.search.replace(/^\?/, "") : "",
          hash: n.hash ? n.hash.replace(/^#/, "") : "",
          hostname: n.hostname,
          port: n.port,
          pathname: n.pathname.charAt(0) === "/" ? n.pathname : "/" + n.pathname
        };
      }
      return a = o(window.location.href), function(l) {
        var y = e.isString(l) ? o(l) : l;
        return y.protocol === a.protocol && y.host === a.host;
      };
    }()
  ) : (
    // Non standard browser envs (web workers, react-native) lack needed support.
    function() {
      return function() {
        return !0;
      };
    }()
  ), ye;
}
var ge, Qe;
function oe() {
  if (Qe)
    return ge;
  Qe = 1;
  function e(r) {
    this.message = r;
  }
  return e.prototype.toString = function() {
    return "Cancel" + (this.message ? ": " + this.message : "");
  }, e.prototype.__CANCEL__ = !0, ge = e, ge;
}
var we, Ye;
function Ze() {
  if (Ye)
    return we;
  Ye = 1;
  var e = P, r = xt(), t = Ct(), n = Er, a = St(), o = Bt(), v = At(), l = Cr(), y = se(), i = oe();
  return we = function(f) {
    return new Promise(function(C, _) {
      var w = f.data, b = f.headers, B = f.responseType, s;
      function m() {
        f.cancelToken && f.cancelToken.unsubscribe(s), f.signal && f.signal.removeEventListener("abort", s);
      }
      e.isFormData(w) && delete b["Content-Type"];
      var u = new XMLHttpRequest();
      if (f.auth) {
        var E = f.auth.username || "", x = f.auth.password ? unescape(encodeURIComponent(f.auth.password)) : "";
        b.Authorization = "Basic " + btoa(E + ":" + x);
      }
      var S = a(f.baseURL, f.url);
      u.open(f.method.toUpperCase(), n(S, f.params, f.paramsSerializer), !0), u.timeout = f.timeout;
      function q() {
        if (u) {
          var A = "getAllResponseHeaders" in u ? o(u.getAllResponseHeaders()) : null, U = !B || B === "text" || B === "json" ? u.responseText : u.response, T = {
            data: U,
            status: u.status,
            statusText: u.statusText,
            headers: A,
            config: f,
            request: u
          };
          r(function(F) {
            C(F), m();
          }, function(F) {
            _(F), m();
          }, T), u = null;
        }
      }
      if ("onloadend" in u ? u.onloadend = q : u.onreadystatechange = function() {
        !u || u.readyState !== 4 || u.status === 0 && !(u.responseURL && u.responseURL.indexOf("file:") === 0) || setTimeout(q);
      }, u.onabort = function() {
        u && (_(l("Request aborted", f, "ECONNABORTED", u)), u = null);
      }, u.onerror = function() {
        _(l("Network Error", f, null, u)), u = null;
      }, u.ontimeout = function() {
        var U = f.timeout ? "timeout of " + f.timeout + "ms exceeded" : "timeout exceeded", T = f.transitional || y.transitional;
        f.timeoutErrorMessage && (U = f.timeoutErrorMessage), _(l(
          U,
          f,
          T.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED",
          u
        )), u = null;
      }, e.isStandardBrowserEnv()) {
        var O = (f.withCredentials || v(S)) && f.xsrfCookieName ? t.read(f.xsrfCookieName) : void 0;
        O && (b[f.xsrfHeaderName] = O);
      }
      "setRequestHeader" in u && e.forEach(b, function(U, T) {
        typeof w == "undefined" && T.toLowerCase() === "content-type" ? delete b[T] : u.setRequestHeader(T, U);
      }), e.isUndefined(f.withCredentials) || (u.withCredentials = !!f.withCredentials), B && B !== "json" && (u.responseType = f.responseType), typeof f.onDownloadProgress == "function" && u.addEventListener("progress", f.onDownloadProgress), typeof f.onUploadProgress == "function" && u.upload && u.upload.addEventListener("progress", f.onUploadProgress), (f.cancelToken || f.signal) && (s = function(A) {
        u && (_(!A || A && A.type ? new i("canceled") : A), u.abort(), u = null);
      }, f.cancelToken && f.cancelToken.subscribe(s), f.signal && (f.signal.aborted ? s() : f.signal.addEventListener("abort", s))), w || (w = null), u.send(w);
    });
  }, we;
}
var be, er;
function se() {
  if (er)
    return be;
  er = 1;
  var e = P, r = Et, t = xr, n = {
    "Content-Type": "application/x-www-form-urlencoded"
  };
  function a(y, i) {
    !e.isUndefined(y) && e.isUndefined(y["Content-Type"]) && (y["Content-Type"] = i);
  }
  function o() {
    var y;
    return (typeof XMLHttpRequest != "undefined" || typeof process != "undefined" && Object.prototype.toString.call(process) === "[object process]") && (y = Ze()), y;
  }
  function v(y, i, g) {
    if (e.isString(y))
      try {
        return (i || JSON.parse)(y), e.trim(y);
      } catch (f) {
        if (f.name !== "SyntaxError")
          throw f;
      }
    return (g || JSON.stringify)(y);
  }
  var l = {
    transitional: {
      silentJSONParsing: !0,
      forcedJSONParsing: !0,
      clarifyTimeoutError: !1
    },
    adapter: o(),
    transformRequest: [function(i, g) {
      return r(g, "Accept"), r(g, "Content-Type"), e.isFormData(i) || e.isArrayBuffer(i) || e.isBuffer(i) || e.isStream(i) || e.isFile(i) || e.isBlob(i) ? i : e.isArrayBufferView(i) ? i.buffer : e.isURLSearchParams(i) ? (a(g, "application/x-www-form-urlencoded;charset=utf-8"), i.toString()) : e.isObject(i) || g && g["Content-Type"] === "application/json" ? (a(g, "application/json"), v(i)) : i;
    }],
    transformResponse: [function(i) {
      var g = this.transitional || l.transitional, f = g && g.silentJSONParsing, R = g && g.forcedJSONParsing, C = !f && this.responseType === "json";
      if (C || R && e.isString(i) && i.length)
        try {
          return JSON.parse(i);
        } catch (_) {
          if (C)
            throw _.name === "SyntaxError" ? t(_, this, "E_JSON_PARSE") : _;
        }
      return i;
    }],
    /**
     * A timeout in milliseconds to abort a request. If set to 0 (default) a
     * timeout is not created.
     */
    timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function(i) {
      return i >= 200 && i < 300;
    },
    headers: {
      common: {
        Accept: "application/json, text/plain, */*"
      }
    }
  };
  return e.forEach(["delete", "get", "head"], function(i) {
    l.headers[i] = {};
  }), e.forEach(["post", "put", "patch"], function(i) {
    l.headers[i] = e.merge(n);
  }), be = l, be;
}
var Ot = P, qt = se(), Tt = function(r, t, n) {
  var a = this || qt;
  return Ot.forEach(n, function(v) {
    r = v.call(a, r, t);
  }), r;
}, Ee, rr;
function Rr() {
  return rr || (rr = 1, Ee = function(r) {
    return !!(r && r.__CANCEL__);
  }), Ee;
}
var tr = P, xe = Tt, Ut = Rr(), Pt = se(), Nt = oe();
function Ce(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new Nt("canceled");
}
var $t = function(r) {
  Ce(r), r.headers = r.headers || {}, r.data = xe.call(
    r,
    r.data,
    r.headers,
    r.transformRequest
  ), r.headers = tr.merge(
    r.headers.common || {},
    r.headers[r.method] || {},
    r.headers
  ), tr.forEach(
    ["delete", "get", "head", "post", "put", "patch", "common"],
    function(a) {
      delete r.headers[a];
    }
  );
  var t = r.adapter || Pt.adapter;
  return t(r).then(function(a) {
    return Ce(r), a.data = xe.call(
      r,
      a.data,
      a.headers,
      r.transformResponse
    ), a;
  }, function(a) {
    return Ut(a) || (Ce(r), a && a.response && (a.response.data = xe.call(
      r,
      a.response.data,
      a.response.headers,
      r.transformResponse
    ))), Promise.reject(a);
  });
}, N = P, _r = function(r, t) {
  t = t || {};
  var n = {};
  function a(g, f) {
    return N.isPlainObject(g) && N.isPlainObject(f) ? N.merge(g, f) : N.isPlainObject(f) ? N.merge({}, f) : N.isArray(f) ? f.slice() : f;
  }
  function o(g) {
    if (N.isUndefined(t[g])) {
      if (!N.isUndefined(r[g]))
        return a(void 0, r[g]);
    } else
      return a(r[g], t[g]);
  }
  function v(g) {
    if (!N.isUndefined(t[g]))
      return a(void 0, t[g]);
  }
  function l(g) {
    if (N.isUndefined(t[g])) {
      if (!N.isUndefined(r[g]))
        return a(void 0, r[g]);
    } else
      return a(void 0, t[g]);
  }
  function y(g) {
    if (g in t)
      return a(r[g], t[g]);
    if (g in r)
      return a(void 0, r[g]);
  }
  var i = {
    url: v,
    method: v,
    data: v,
    baseURL: l,
    transformRequest: l,
    transformResponse: l,
    paramsSerializer: l,
    timeout: l,
    timeoutMessage: l,
    withCredentials: l,
    adapter: l,
    responseType: l,
    xsrfCookieName: l,
    xsrfHeaderName: l,
    onUploadProgress: l,
    onDownloadProgress: l,
    decompress: l,
    maxContentLength: l,
    maxBodyLength: l,
    transport: l,
    httpAgent: l,
    httpsAgent: l,
    cancelToken: l,
    socketPath: l,
    responseEncoding: l,
    validateStatus: y
  };
  return N.forEach(Object.keys(r).concat(Object.keys(t)), function(f) {
    var R = i[f] || o, C = R(f);
    N.isUndefined(C) && R !== y || (n[f] = C);
  }), n;
}, Re, nr;
function Sr() {
  return nr || (nr = 1, Re = {
    version: "0.25.0"
  }), Re;
}
var Lt = Sr().version, Fe = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach(function(e, r) {
  Fe[e] = function(n) {
    return typeof n === e || "a" + (r < 1 ? "n " : " ") + e;
  };
});
var ar = {};
Fe.transitional = function(r, t, n) {
  function a(o, v) {
    return "[Axios v" + Lt + "] Transitional option '" + o + "'" + v + (n ? ". " + n : "");
  }
  return function(o, v, l) {
    if (r === !1)
      throw new Error(a(v, " has been removed" + (t ? " in " + t : "")));
    return t && !ar[v] && (ar[v] = !0, console.warn(
      a(
        v,
        " has been deprecated since v" + t + " and will be removed in the near future"
      )
    )), r ? r(o, v, l) : !0;
  };
};
function Ft(e, r, t) {
  if (typeof e != "object")
    throw new TypeError("options must be an object");
  for (var n = Object.keys(e), a = n.length; a-- > 0; ) {
    var o = n[a], v = r[o];
    if (v) {
      var l = e[o], y = l === void 0 || v(l, o, e);
      if (y !== !0)
        throw new TypeError("option " + o + " must be " + y);
      continue;
    }
    if (t !== !0)
      throw Error("Unknown option " + o);
  }
}
var kt = {
  assertOptions: Ft,
  validators: Fe
}, Br = P, It = Er, ir = wt, or = $t, ue = _r, Ar = kt, D = Ar.validators;
function W(e) {
  this.defaults = e, this.interceptors = {
    request: new ir(),
    response: new ir()
  };
}
W.prototype.request = function(r, t) {
  if (typeof r == "string" ? (t = t || {}, t.url = r) : t = r || {}, !t.url)
    throw new Error("Provided config url is not valid");
  t = ue(this.defaults, t), t.method ? t.method = t.method.toLowerCase() : this.defaults.method ? t.method = this.defaults.method.toLowerCase() : t.method = "get";
  var n = t.transitional;
  n !== void 0 && Ar.assertOptions(n, {
    silentJSONParsing: D.transitional(D.boolean),
    forcedJSONParsing: D.transitional(D.boolean),
    clarifyTimeoutError: D.transitional(D.boolean)
  }, !1);
  var a = [], o = !0;
  this.interceptors.request.forEach(function(C) {
    typeof C.runWhen == "function" && C.runWhen(t) === !1 || (o = o && C.synchronous, a.unshift(C.fulfilled, C.rejected));
  });
  var v = [];
  this.interceptors.response.forEach(function(C) {
    v.push(C.fulfilled, C.rejected);
  });
  var l;
  if (!o) {
    var y = [or, void 0];
    for (Array.prototype.unshift.apply(y, a), y = y.concat(v), l = Promise.resolve(t); y.length; )
      l = l.then(y.shift(), y.shift());
    return l;
  }
  for (var i = t; a.length; ) {
    var g = a.shift(), f = a.shift();
    try {
      i = g(i);
    } catch (R) {
      f(R);
      break;
    }
  }
  try {
    l = or(i);
  } catch (R) {
    return Promise.reject(R);
  }
  for (; v.length; )
    l = l.then(v.shift(), v.shift());
  return l;
};
W.prototype.getUri = function(r) {
  if (!r.url)
    throw new Error("Provided config url is not valid");
  return r = ue(this.defaults, r), It(r.url, r.params, r.paramsSerializer).replace(/^\?/, "");
};
Br.forEach(["delete", "get", "head", "options"], function(r) {
  W.prototype[r] = function(t, n) {
    return this.request(ue(n || {}, {
      method: r,
      url: t,
      data: (n || {}).data
    }));
  };
});
Br.forEach(["post", "put", "patch"], function(r) {
  W.prototype[r] = function(t, n, a) {
    return this.request(ue(a || {}, {
      method: r,
      url: t,
      data: n
    }));
  };
});
var jt = W, _e, sr;
function Dt() {
  if (sr)
    return _e;
  sr = 1;
  var e = oe();
  function r(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    var n;
    this.promise = new Promise(function(v) {
      n = v;
    });
    var a = this;
    this.promise.then(function(o) {
      if (a._listeners) {
        var v, l = a._listeners.length;
        for (v = 0; v < l; v++)
          a._listeners[v](o);
        a._listeners = null;
      }
    }), this.promise.then = function(o) {
      var v, l = new Promise(function(y) {
        a.subscribe(y), v = y;
      }).then(o);
      return l.cancel = function() {
        a.unsubscribe(v);
      }, l;
    }, t(function(v) {
      a.reason || (a.reason = new e(v), n(a.reason));
    });
  }
  return r.prototype.throwIfRequested = function() {
    if (this.reason)
      throw this.reason;
  }, r.prototype.subscribe = function(n) {
    if (this.reason) {
      n(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(n) : this._listeners = [n];
  }, r.prototype.unsubscribe = function(n) {
    if (this._listeners) {
      var a = this._listeners.indexOf(n);
      a !== -1 && this._listeners.splice(a, 1);
    }
  }, r.source = function() {
    var n, a = new r(function(v) {
      n = v;
    });
    return {
      token: a,
      cancel: n
    };
  }, _e = r, _e;
}
var Se, ur;
function Ht() {
  return ur || (ur = 1, Se = function(r) {
    return function(n) {
      return r.apply(null, n);
    };
  }), Se;
}
var Be, fr;
function Vt() {
  if (fr)
    return Be;
  fr = 1;
  var e = P;
  return Be = function(t) {
    return e.isObject(t) && t.isAxiosError === !0;
  }, Be;
}
var lr = P, Mt = yr, te = jt, Wt = _r, zt = se();
function Or(e) {
  var r = new te(e), t = Mt(te.prototype.request, r);
  return lr.extend(t, te.prototype, r), lr.extend(t, r), t.create = function(a) {
    return Or(Wt(e, a));
  }, t;
}
var L = Or(zt);
L.Axios = te;
L.Cancel = oe();
L.CancelToken = Dt();
L.isCancel = Rr();
L.VERSION = Sr().version;
L.all = function(r) {
  return Promise.all(r);
};
L.spread = Ht();
L.isAxiosError = Vt();
Ne.exports = L;
Ne.exports.default = L;
var Jt = Ne.exports, Xt = Jt;
const Gt = /* @__PURE__ */ Pe(Xt), Ae = (e, r, t) => {
  $.logInfo(`${e.name}: ${r} => ${t}`);
};
class Kt {
  constructor(r, t) {
    this.settings = r, this.httpClient = t || Gt.create(), this.getContext = r.getContext, this.onTrack = r.onTrack, this.onUpdated = r.onUpdated, this.observer = new rt(this), this.override = r.urlString ? new tt(r.urlString) : null;
  }
  getQualifiedKey(r) {
    if (r.includes("::"))
      return r;
    const { keyPrefix: t } = this.settings;
    return t ? `${t}::${r}` : r;
  }
  getValue(r, t = !0) {
    try {
      const n = Ur(this.getQualifiedKey(r));
      if (!n)
        return null;
      const a = this.override ? this.override.getOverride(r, n.valueType) : null;
      if (a !== null)
        return a;
      const o = this.getContext();
      if (!o)
        return $.logError(
          "Unable to provide feature values as no context was provided. Check your settings for the plugin"
        ), null;
      const v = Yr(n, o);
      return v ? (t && v.experimentKey && v.experimentVariant && et(v, this.onTrack), v.value) : Zr(n, o);
    } catch (n) {
      const a = n instanceof Error ? n.message : "Unknown error";
      $.logError(a, { error: n });
    }
    return null;
  }
  getBooleanValue(r) {
    const t = this.getValue(r);
    return typeof t != "boolean" ? null : (Ae(this.getBooleanValue, r, t), t);
  }
  getIntegerValue(r) {
    const t = this.getValue(r);
    return typeof t == "number" ? (Ae(this.getIntegerValue, r, t), t) : null;
  }
  getStringValue(r) {
    const t = this.getValue(r);
    return typeof t == "string" ? (Ae(this.getStringValue, r, t), t) : null;
  }
  loadFromCdn() {
    if (!this.settings.cdn)
      throw new Error("CDN settings were not provided.");
    return Tr(this.settings.cdn, this.httpClient, this.onUpdated);
  }
  updateConfig(r) {
    Ue(r);
  }
}
let ee;
const Yt = (e, r) => (ee && e.reinitialise !== !0 || (e.logger && e.logger && qr(e.logger), e.initialConfigAsJson && Ue(e.initialConfigAsJson), e.getContext || (e.getContext = Nr), ee = new Kt(e, r)), ee);
export {
  Yt as createFeatureManager
};
